/**
 * Steht der Rueckblick aus? (F-40) - dieselbe Regel wie in der Glocke:
 * ab dem Rueckblick-Tag (Standard Sonntag) und an den zwei Tagen danach.
 * Er ist bewusst zurueckhaltend: der einzige Hinweis, der in dieser App
 * hartnaeckig sein darf, ist die Erinnerung an die Datensicherung.
 */
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import { faelligeWoche } from '@/domain/review/faellig';
import { useBenachrichtigungsEinstellungen } from '@/modules/benachrichtigungen/useMeldungen';
import { today } from '@/lib/datetime';

/** Die faellige Woche (`key` wie `'2026-W40'`, `name` wie `'KW 40'`), sonst `null`. */
export function useReviewDue(): { key: string; name: string } | null {
  const { rueckblickTag } = useBenachrichtigungsEinstellungen();
  const kw = faelligeWoche(today(), rueckblickTag);

  const vorhanden = useLiveQuery(
    async () => (kw ? (await db.weeklyReviews.get(kw)) !== undefined : true),
    [kw],
    true,
  );

  if (!kw || vorhanden) return null;
  return { key: kw, name: `KW ${Number(kw.slice(-2))}` };
}
